export const ROLLOVER_HOUR = 6;

export const businessDayStart = (at: Date = new Date()): Date => {
    const d = new Date(at);
    if (d.getHours() < ROLLOVER_HOUR) d.setDate(d.getDate() - 1);
    d.setHours(ROLLOVER_HOUR, 0, 0, 0);
    return d;
};

export const businessDayString = (at: Date = new Date()): string => {
    const start = businessDayStart(at);
    const m = String(start.getMonth() + 1).padStart(2, '0');
    const d = String(start.getDate()).padStart(2, '0');
    return `${m}-${d}-${start.getFullYear()}`;
};

export default businessDayString;
